export default "__VITE_ASSET__eLizfumb__"